var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_923_50323)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.52631 5.1709H15.0059C15.7577 5.1709 16.4522 5.57249 16.8273 6.22398L18.7167 8.80503C19.0918 9.45652 19.7864 9.85812 20.5381 9.85812H40.4999C44.9182 9.85812 48.4999 13.4398 48.4999 17.8581V39.3263C48.4999 40.874 47.2452 42.1287 45.6975 42.1287H3.30235C1.7547 42.1287 0.5 40.874 0.5 39.3263V13.127C0.5 10.9609 0.834662 8.8077 1.4922 6.74376C1.73307 5.81747 2.56927 5.1709 3.52631 5.1709Z",
    fill: "#4DA8B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.7641 9.37598H4.86816V24.9619H41.7641V9.37598Z",
    fill: "#FAFDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.3982 6.57178H34.83C34.0073 6.57178 33.2602 7.05178 32.9184 7.80003L30.9388 12.1324C30.5968 12.8806 29.8498 13.3607 29.0272 13.3607H8.5C4.08172 13.3607 0.5 16.9424 0.5 21.3607V40.0265C0.5 41.5742 1.7547 42.8289 3.30235 42.8289H45.6977C47.2453 42.8289 48.5 41.5742 48.5 40.0265V8.67354C48.5 7.51283 47.5589 6.57178 46.3982 6.57178Z",
    fill: "#4DA8B7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_923_50323"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/Folder.3c9a75e7e39f8d0cbcad1487a0490af5.svg";
export { ForwardRef as ReactComponent };